import * as React from 'react';
import noise from './noise';
import { BACKGROUND_COLOR, COLOR_A, COLOR_B, COLOR_A_RGB } from './CONSTANTS';
import { Surface } from 'gl-react-dom'; // for React DOM
import { Shaders, Node, GLSL } from 'gl-react';

const PI = 3.1415;
class OTDisplayGL extends React.Component {
	constructor(props) {
		super(props);
		this.wrapperRef = React.createRef();
	}

	componentDidMount() {
		const { OTGain, overtones } = this.props;
	}

	render() {
		const { OTGain, overtones, Q } = this.props;
		return (
			<div style={{ height: '100%', width: '100%' }} ref={this.wrapperRef}>
				{this.wrapperRef.current && (
					<Surface width={this.wrapperRef.current.offsetWidth} height={this.wrapperRef.current.offsetHeight}>
						<OT
							overtones={overtones}
							OTGain={OTGain}
							r={COLOR_A_RGB.r / 255.0}
							g={COLOR_A_RGB.g / 255.0}
							b={COLOR_A_RGB.b / 255.0}
							Q={Q}
							time={performance.now() / 200}
						/>
					</Surface>
				)}
			</div>
		);
	}
}

export default OTDisplayGL;

const shaders = Shaders.create({
	helloBlue: {
		frag: GLSL`
  precision highp float;
  varying vec2 uv;
  uniform float r,g,b;
  uniform float time;
  uniform float ot1,ot3,ot5,ot7,ot9;
  uniform float Q;
  void main() {
	float amnt;
	float nd;
	float ip;
	float alpha;
	vec4 cbuff = vec4(0.0);
	for(float i=0.0; i<10.0;i++){
		
	ip=i-2.0;
	  nd = 1.0/4.0*ot1*sin(uv.x*2.0*3.14+ip*0.4+time*0.2)/2.0;

	  nd += 1.0/4.0*ot3*sin(3.0*uv.x*2.0*3.14+ip*0.4)/2.0;

	  nd += 1.0/4.0*ot5*sin(5.0*uv.x*2.0*3.14+ip*0.4)/2.0;

	  nd += 1.0/4.0*ot7*sin(7.0*uv.x*2.0*3.14+ip*0.4)/2.0;

	  nd/=5.0;
	  nd+=0.5;
	  amnt = 1.0/abs(nd-uv.y)*0.01;
	  alpha=(10.0-i)/5.0;
	  cbuff += vec4(amnt*alpha*0.3, amnt*0.3*alpha , amnt*uv.y*alpha,0) ;
	}

	for(float i=0.0; i<10.0;i++){
	  nd = sin(3.14*10.0*uv.y + i*40.5 + time)*10.3*(uv.y+80.3)+0.5;
	  amnt = 10.0/abs(nd-uv.x-0.6-uv.y)/Q;
	  cbuff += 1./Q-vec4(amnt*0.2, amnt*0.2 , amnt*uv.x, 1.0); //MULTIPLY THIS BY HP GAIN (HP NOISE)
	}
	gl_FragColor = vec4(cbuff[0]*r,cbuff[1]*g,cbuff[2]*b,1.0);
  }`,
	},
});
class OT extends React.Component {
	render() {
		const { r, g, b, time, OTGain, overtones, Q } = this.props;
		const oTG = {};
		const ovt = {};
		OTGain.forEach((ot, idx) => (oTG['ot' + overtones[idx]] = ot));
		return <Node shader={shaders.helloBlue} uniforms={{ r, g, b, time, ...oTG, Q }} />;
	}
}
